import { render } from "./TicketTestimonials.vue?vue&type=template&id=248adc52&scoped=true"
const script = {}

import "./TicketTestimonials.vue?vue&type=style&index=0&id=248adc52&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248adc52"]])

export default __exports__